import { IonAlert, IonContent, IonRefresher, IonRefresherContent, IonToolbar, useIonViewDidEnter, useIonViewDidLeave, useIonViewWillEnter, useIonViewWillLeave } from '@ionic/react';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getConfig } from '../../appConfig';
import Header from '../../components/header';
import { forwardTo, getRouteClassName, isWebConfig } from '../../lib/utils';
import { SET_COMMON_PROP } from '../../store/constants';
import { Title } from '../common';
import StaticHeader from '../staticHeader';
import './index.css';

const defaultHeaderTitle = getConfig().general.clientName;

const Layout = ({
	history,
	children,
	headerTitle,
	showSecondToolbar,
	hideBack,
	color,
	poster,
	blank,
	noPadding,
	contentClassName,
	scrollY,
	backHandler,
	selectCategoryOnScroll,
	navConfig,
	showHamburger,
	headerIconColors,
	withRefresher,
	onRefreshHandler,
	headerWithTitle,
	clientProfile,
	profile,
	title,
	style,
	hasSearchIcon,
	onSearchHandler,
	searchActive,
	tableData,
	onTitleClickHandler,
	selenium,
	showLoginIcon,
}) => {
	useIonViewWillEnter(() => {
		// eslint-disable-next-line no-console
		console.log('1. WillEnter event fired');
	});
	useIonViewDidEnter(() => {
		// eslint-disable-next-line no-console
		console.log('2. DidEnter event fired');
	});
	useIonViewWillLeave((a, b, c) => {
		// eslint-disable-next-line no-console
		console.log('3. WillLeave event fired', a, b, c);
	});
	useIonViewDidLeave((a, b, c) => {
		// eslint-disable-next-line no-console
		console.log('4. DidLeave event fired', a, b, c);
	});
	const routeClassName = getRouteClassName(history.location.pathname, navConfig);
	const logo = clientProfile.logo_image || '';
	const lightspeedError = tableData?.lightspeed_error || false;
	const tableRoutes =
		history.location.pathname == '/split-bill' ||
		history.location.pathname == '/split-bill-by-amount' ||
		history.location.pathname == '/split-bill-by-items' ||
		history.location.pathname == '/table-overview';
	return (
		<>
			{!profile.is_guest ? (
				<>
					{blank ? null : (
						<>
							{!showSecondToolbar ? (
								<StaticHeader
									hasSearchIcon={hasSearchIcon}
									hideBack={hideBack}
									backHandler={backHandler}
									showHamburger={showHamburger}
									headerIconColors={headerIconColors}
									headerWithTitle={headerWithTitle}
									title={title}
									onSearchHandler={onSearchHandler}
									searchActive={searchActive}
									onTitleClickHandler={onTitleClickHandler}
									showLoginIcon={showLoginIcon}
								/>
							) : (
								<>
									<StaticHeader
										hasSearchIcon={hasSearchIcon}
										hideBack={hideBack}
										backHandler={backHandler}
										headerIconColors={headerIconColors}
										headerWithTitle={headerWithTitle}
										title={title}
										onSearchHandler={onSearchHandler}
										searchActive={searchActive}
										onTitleClickHandler={onTitleClickHandler}
										showLoginIcon={showLoginIcon}
									/>
									<Header title={headerTitle || defaultHeaderTitle} hideBack={hideBack} backHandler={backHandler} />
								</>
							)}
						</>
					)}
				</>
			) : (
				<>
					{!isWebConfig() && (
						<IonToolbar
							color="transparent"
							className="primary-toolbar"
							style={{
								backgroundSize: 'auto 35px',
								backgroundImage: !isWebConfig() && !headerWithTitle ? `url(${logo})` : '',
								backgroundRepeat: 'no-repeat',
								backgroundPosition: 'center',
							}}
						>
							{headerWithTitle && <Title className="centered">{title}</Title>}
						</IonToolbar>
					)}
				</>
			)}

			<IonContent
				scrollY={scrollY !== undefined ? scrollY : true}
				color={color || 'white'}
				className={routeClassName + (contentClassName ? ' ' + contentClassName : '')}
				selenium={selenium || ''}
			>
				{withRefresher && !isWebConfig() && (
					<IonRefresher pullFactor="0.8" onIonRefresh={(e) => onRefreshHandler(e)} slot="fixed">
						<IonRefresherContent pullingIcon="chevron-down-circle-outline"></IonRefresherContent>
					</IonRefresher>
				)}
				{poster ? <div className={'poster ' + poster} /> : null}
				<div style={style} className={noPadding ? 'no-padding' : 'ion-padding'} onScroll={routeClassName === 'route-order' ? selectCategoryOnScroll : null}>
					{lightspeedError && tableRoutes && (
						<div className="error-overlay">
							<IonAlert
								isOpen={true}
								message={getConfig().billPayOptions.errorMessage || 'An error has occurred'}
								buttons={[
									{
										text: 'OK',
										handler: () => forwardTo('/table-bill-pay'),
									},
								]}
								backdropDismiss={false}
							/>
						</div>
					)}

					{withRefresher && isWebConfig() && (
						<IonRefresher pullFactor="0.8" onIonRefresh={(e) => onRefreshHandler(e)} slot="fixed">
							<IonRefresherContent {...(!isWebConfig() ? { pullingIcon: 'chevron-down-circle-outline' } : {})}></IonRefresherContent>
						</IonRefresher>
					)}
					{children}
				</div>
			</IonContent>
		</>
	);
};

function mapStateToProps(state) {
	return {
		navConfig: state.common.navConfig,
		profile: state.profile.profile,
		clientProfile: state.common.clientProfile,
		tableData: state.restaurants.tableData,
	};
}
export default connect(mapStateToProps)(withRouter(Layout));
